<template>
  <div>
    <div class="icon-list f--c">
      <div class="item f-c-c pointer icon_logistics" @click="jump('/mall/shipping-cost')">
        <icon-park type="Transporter" theme="outline" size="20" fill="#333" />
      </div>
      <div v-if="userId" class="item f-c-c pointer icon_notification">
        <el-popover placement="bottom" :width="500" trigger="click" @show="showRemind">
          <template #reference>
            <icon-park type="Remind" theme="outline" size="20" fill="#333" />
          </template>
          <!-- <HeaderInformBox ref="popoverInformBox" @showNewFunction="showNewFunction" /> -->
          <inform-box @showNewFunction="showNewFunction" />
        </el-popover>
      </div>
      <div v-if="userId" class="item f-c-c pointer icon_question" @click="jump('/help-center')">
        <icon-park type="Help" theme="outline" size="20" fill="#333" />
      </div>
      <el-dropdown v-if="userId" trigger="click" popper-class="head-dropdown" @command="handleCommand">
        <div class="item f-c-c pointer icon_user">
          <icon-park type="Me" theme="outline" size="20" fill="#333" />
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="user" class="dropdown-username f--c">
              <icon-park type="User" theme="outline" size="16" fill="#333" style="margin-right:4px" />
              <div class="name ellipsis">
                {{ $store.state.common.userName }}
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/publish/productList" divided>{{$t('headerBar.wishList')}}</el-dropdown-item>
            <el-dropdown-item command="/publish/listings">{{$t('headerBar.listing')}}</el-dropdown-item>
            <el-dropdown-item command="/order/list">{{$t('headerBar.allOrder')}}</el-dropdown-item>
            <el-dropdown-item command="/personal-center/account-setting">{{$t('Index.Components.Header.PersonalCenter')}}</el-dropdown-item>
            <el-dropdown-item command="logout">{{$t('headerBar.logOut')}}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="item f-c-c pointer icon_user_mobile" @click="showMobileNav">
        <icon-park type="Me" theme="outline" size="20" fill="#333" />
      </div>
      <div v-if="userId" class="item f-c-c pointer icon_shop" @click="jump('/mall/shoppingCar')">
        <icon-park type="Buy" theme="outline" size="20" fill="#333" />
      </div>
      <div v-if="userId" class="item f-c-c pointer icon_shop_mobile" @click="jump('/mall/mobileCart')">
        <icon-park type="Buy" theme="outline" size="20" fill="#333" />
      </div>
      <div class="item f-c-c pointer icon_fold" @click="showMobileCategory">
        <icon-park type="HamburgerButton" theme="outline" size="20" fill="#333" />
      </div>
      <div v-if="!userId" class="sign-in" @click="jump('/login')">
        {{$t('headerBar.login')}}
      </div>
      <div v-if="!userId" class="sign-up" @click="jump('/register')">
        <el-button type="primary" size="large">{{$t('headerBar.register')}}</el-button>
      </div>
    </div>

    <!-- 通知弹窗 -->
    <!-- <el-dialog v-model="dialogVisible" width="80%" :append-to-body="true" class="new-function">
      <HeaderInformBox ref="dialogInformBox" :isDiadlog="true" />
    </el-dialog> -->

    <!-- 用户导航，自定义导航 -->
    <!-- <HeaderMobileNav ref="drawerMobileNav" /> -->
    <NewMobileNav ref="drawerMobileNav" />

    <!-- 品类菜单 -->
    <!-- <NewMobileNav ref="drawerMobileCategory" /> -->
    <product-menu ref="productMenu"></product-menu>
  </div>
</template>
<script>
import API from '@/api'
import { IconPark } from '@icon-park/vue/es/all'
import InformBox from '@/components/InformBox.vue'
import NewMobileNav from '@/components/NewMobileNav.vue'
import ProductMenu from '@/components/mobile/ProductMenu.vue'
export default {
  components: { IconPark, InformBox, NewMobileNav, ProductMenu },
  data() {
    return {
      mainDomain: process.env.VUE_APP_MAIN_DOMAIN,
      dialogVisible: false
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  methods: {
    showRemind() {
      this.$refs.popoverInformBox.newFunctionGetList()
    },
    showNewFunction(tabs, id) {
      this.$emit('showNewFunction', tabs)
    },
    handleCommand(command) {
      if (command === 'user') {
        console.log(this.$store.state.common.userName)
      } else if (command === 'logout') {
        this.logOut()
      } else {
        location.href = command
      }
    },
    jump(path) {
      if (path === '/mall/mobileCart') {
        window.open(path, '_blank')
      } else this.$router.push(path) // location.href = `${path}`
    },
    showMobileNav() {
      this.$refs.drawerMobileNav.show()
    },
    showMobileCategory() {
      this.$refs.productMenu.show()
    },

    logOut() {
      API.logout().finally(() => {
        this.$store.dispatch('logOut')
      })
    }
  }
}

// // 显示通知气泡框
// const popoverInformBox = ref(null)
// const showRemind = () => {
//   if (popoverInformBox.value) {
//     popoverInformBox.value.newFunctionGetList()
//   }
// }

// // 打开通知弹窗
// const dialogVisible = ref(false)
// const dialogInformBox = ref(null)
// const showNewFunction = (activeName) => {
//   dialogVisible.value = true
//   nextTick(() => {
//     if (dialogInformBox.value) {
//       dialogInformBox.value.activeName = activeName
//       switch (+activeName) {
//         case 3:
//           dialogInformBox.value.productTakeDownSendsList()
//           break;
//         case 4:
//           dialogInformBox.value.getFileTaskList()
//           break;
//         default:
//           dialogInformBox.value.newFunctionGetList()
//           break;
//       }
//     }
//   })
// }

// // 打开用户导航
// const drawerMobileNav = ref(null)
// const showMobileNav = () => {
//   if (drawerMobileNav.value) {
//     drawerMobileNav.value.mobileUserNav = true
//   }
// }

// // 打开品类菜单
// const drawerMobileCategory = ref(null)
// const showMobileCategory = () => {
//   if (drawerMobileCategory.value) {
//     drawerMobileCategory.value.mobileCategory = true
//   }
// }

// //
// const handleCommand = (command) => {
//   if (command === 'user') {

//   } else if (command === 'logout') {
//     vuex.logOut()
//   } else {
//     location.href = command
//   }
// }

// const jump = (path) => {
//   if (path === '/mall/mobileCart') {
//     window.open(path, '_blank')
//   } else location.href = `${path}`
// }

</script>
<style lang="scss" scoped>
.icon-list {
  font-size: #333;
  .item {
    width: 40px;
    height: 40px;
    margin-left: 8px;
    border-radius: 50%;
    transition: background-color .3s cubic-bezier(.645,.045,.355,1);
    > img {
      width: 20px;
      height: 20px;
    }
    .i-icon {
      display: flex;
    }
  }
  .item:hover {
    background-color: #efefef;
  }
  .icon_search, .icon_fold, .icon_user_mobile, .icon_shop_mobile {
    display: none;
  }

  .sign-in, .sign-up {
    margin-left: 24px;
  }
  .sign-in {
    cursor: pointer;
    font-size: 16px;
    white-space: nowrap;
  }
}

@media only screen and (max-width: 1024px) {
  .icon-list .icon_rate {
    display: none;
  }
}
@media only screen and (max-width: 1000px) {
  .icon-list {
    .icon_search, .icon_fold, .icon_user_mobile, .icon_shop_mobile {
      display: flex;
    }
    .icon_notification, .icon_logistics, .icon_rate, .icon_question, .icon_user, .sign-in, .sign-up, .icon_shop {
      display: none;
    }
  }
}

// @media only screen and (max-width: 600px) {
//   .icon-list .icon_question {
//     display: none;
//   }
// }
// @media only screen and (max-width: 500px) {
//   .icon-list .icon_user {
//     display: none;
//   }
// }
</style>
<style lang="scss">
.head-dropdown {
  .el-dropdown-menu__item {
    font-size: 13px;
    font-weight: 400;
  }
  .dropdown-username {
    font-size: 14px;
    font-weight: 500;
    .name {
      max-width: 160px;
    }
  }
}
</style>
